<template>
  <v-card class="my-2" :flat="!isSelected" :color="cardColor">
    <v-card-title>
      {{ binderData.name }}
    </v-card-title>
    <v-card-subtitle> Placed: {{ binderData.placed }} </v-card-subtitle>
    <v-card-actions>
      <v-layout align-center="true">
        <v-flex class="mr-1"
          ><v-btn
            block
            tile
            :elevation="isRegistered ? 5 : 0"
            @click="registerBinder()"
            :color="registerButtonColor()"
            >Register</v-btn
          ></v-flex
        >
        <v-flex
          ><v-btn
            block
            tile
            :elevation="!isRegistered && isSelected ? 5 : 0"
            @click="deRegisterBinder()"
            :color="deRegisterButtonColor()"
            >De-Register</v-btn
          ></v-flex
        >
      </v-layout>
    </v-card-actions>
    <v-card-text v-if="isSelected">
      <v-row class="mt-2" v-if="isRegistered">
        <v-col>
          <v-slider
            v-model="registerAmount"
            :max="max"
            :min="min"
            thumb-label="always"
            :rules="rules"
            label="Amount"
          >
            <template v-slot:append>
              <v-text-field
                v-model="registerAmount"
                class="mt-0 pt-0"
                hide-details
                single-line
                type="number"
                style="width: 60px"
              ></v-text-field>
            </template>
          </v-slider>
        </v-col>
      </v-row>
      <v-row class="mt-2" v-if="!isRegistered">
        <v-col>
          <v-slider
            v-model="deRegisterUsableAmount"
            :max="max"
            :min="min"
            thumb-label="always"
            :rules="deUseRules"
            label="Usable"
          >
            <template v-slot:append>
              <v-text-field
                v-model="deRegisterUsableAmount"
                class="mt-0 pt-0"
                hide-details
                single-line
                type="number"
                style="width: 60px"
              ></v-text-field>
            </template>
          </v-slider>
        </v-col>
      </v-row>
      <v-row class="mt-2" v-if="!isRegistered">
        <v-col>
          <v-slider
            v-model="deRegisterNotUsableAmount"
            :max="max"
            :min="min"
            thumb-label="always"
            :rules="deNotUseRules"
            label="Not Usable"
          >
            <template v-slot:append>
              <v-text-field
                v-model="deRegisterNotUsableAmount"
                class="mt-0 pt-0"
                hide-details
                single-line
                type="number"
                style="width: 60px"
              ></v-text-field>
            </template>
          </v-slider>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapMutations } = createNamespacedHelpers("customer/");
export default {
  name: "Binder",
  props: ["binderData"],
  data() {
    return {
      max: 100,
      min: 0,
      rules: [
        v =>
          v <= this.binderData.placed || `Only ${this.binderData.placed} placed`
      ],
      deUseRules: [
        v =>
          v + this.deRegisterNotUsableAmount <= this.binderData.placed ||
          `Only ${this.binderData.placed} placed`
      ],
      deNotUseRules: [
        v =>
          v + this.deRegisterUsableAmount <= this.binderData.placed ||
          `Only ${this.binderData.placed} placed`
      ],
      register: this.binderData.register ? this.binderData.register : "",
      registerAmount: this.binderData.registerAmount
        ? this.binderData.registerAmount
        : 0,
      deRegisterUsableAmount: this.binderData.deRegisterUsableAmount
        ? this.binderData.deRegisterUsableAmount
        : 0,
      deRegisterNotUsableAmount: this.binderData.deRegisterNotUsableAmount
        ? this.binderData.deRegisterNotUsableAmount
        : 0
    };
  },
  computed: {
    isSelected() {
      return this.register !== "";
    },
    isRegistered() {
      return this.register;
    },
    cardColor() {
      if (!this.isSelected) {
        return "default";
      }

      return this.isRegistered ? "#dceec7" : "#eed4cc";
    }
  },
  methods: {
    ...mapMutations([
      "registerB",
      "unregister",
      "deregister",
      "setRegisterAmount",
      "setDeRegisterUsableAmount",
      "setDeRegisterNotUsableAmount",
      "setNeedsSaved"
    ]),
    registerBinder() {
      this.setNeedsSaved();
      if (this.register) {
        this.unregister(this.binderData.binderId);
        this.register = "";
      } else {
        this.registerB(this.binderData.binderId);
        this.setDeRegisterUsableAmount(this.binderData.binderId, 0);
        this.setDeRegisterNotUsableAmount(this.binderData.binderId, 0);
        this.register = true;
        this.deRegisterUsableAmount = 0;
        this.deRegisterNotUsableAmount = 0;
      }
    },
    deRegisterBinder() {
      this.setNeedsSaved();
      if (this.register === false) {
        this.unregister(this.binderData.binderId);
        this.register = "";
      } else {
        this.deregister(this.binderData.binderId);
        this.setRegisterAmount(this.binderData.binderId, 0);
        this.register = false;
        this.registerAmount = 0;
      }
    },
    registerButtonColor() {
      return this.isRegistered ? "success" : "default";
    },
    deRegisterButtonColor() {
      return this.isRegistered === false ? "error" : "default";
    }
  }
};
</script>

<style scoped></style>
